import { createSlice } from '@reduxjs/toolkit';

const BarController = createSlice({
    name:'bar_controller',
    initialState:{
        value:'hidden'
    },
    reducers:{
        toggle:{
            reducer:(state, action) => (state = action.payload),
            prepare: (value) => ({ payload: value }),
        }
    }
})

export const {toggle} = BarController.actions;
export default BarController.reducer
